<div class="my-layout-splashscreen-container"
  [ngClass]="{
    'my-layout-splashscreen-container-active': (layoutSplashscreenService.isActive$ | async),
    'my-layout-splashscreen-container-completed': (layoutSplashscreenService.isAnimationCompleted$ | async)
  }"
  [@layoutCoreSplashscreenAnimation]="animation"
  (@layoutCoreSplashscreenAnimation.done)="onAnimationComplete($event)"
  >
  <div class="my-layout-splashscreen-overlay"></div>
  <div class="my-layout-splashscreen-wrapper">
    <div class="my-layout-splashscreen-logo" [@layoutCoreSplashscreenLogoAnimation]='true'></div>
    <div class="my-layout-splashscreen-rounded-bottom">
      <div></div>
    </div>
  </div>
</div>
